export default "__VITE_ASSET__xB9iIEEx__"